import styled from "styled-components/macro";

const breakpoints = {
  tablet: "screen and (max-width: 960px)",
  smallLaptop: "screen and (max-width: 1300px)",
  lg: "screen (max-width: 1530px)",
  xl: "screen and (min-width: 1531px)",
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* background-color: #f3f1e4; */
  /* <div style={{width: '100%', height: '100%', opacity: 0.80, mixBlendMode: 'multiply', background: 'linear-gradient(0deg, #016FC5 0%, #016FC5 100%), linear-gradient(90deg, rgba(0, 19, 29, 0.70) 0%, rgba(31.94, 63.48, 102.03, 0.59) 48%, rgba(39.07, 48.30, 40.55, 0.40) 77%, rgba(37.33, 49.34, 39.25, 0) 100%)', boxShadow: '34px 34px 34px ', filter: 'blur(34px)'}} /> */
  .light {
      svg {
        path{
          fill: #fff;
        }
      }
    }

  .corner-logo {
      position: absolute;
      top: 70px;
      left: 90px;
      opacity: .3;
      z-index: 10000;
      svg{
        width: 150px;
        height: 100px;
      }

  }
  .creator {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    flex-grow: 1;
    padding: 8em 70px 8em 20px;

    mix-blend-mode: "multiply";
    position: relative;
    filter: "blur(34px)";
    height:calc(100vh - 16em);
    /* background-image: url('path-to-your-image.jpg'); */
    background-size: cover;
    min-height: 600px;



    .plugins-tray{
      display: none;
      .plugin{
        color: #383838;
      }
    }
    .plugins-inline{
      display: block;
      margin-top:36px;
      .plugin{
        box-shadow: var(--card-drop-shadow);
        max-width: 350px;
        color: #383838;
      }
    }

    .border {
      position: absolute;
      margin-top: 0;
      width: calc(100% - 100px);
      height: calc(100% - 100px);
      top: 50px;
      /* right: 10px; */
      left: 50px;
      /* right: 50px; */
      border: 3px solid var(--grey-3);
      border-radius: 40px;
      z-index: 0;
    }


    .image {
      position: absolute;
      width: calc((70vw + 70vh) / 2);
      height: auto;
      bottom: 0;
      left:0;
      background-size: 50%;
      background-position: left bottom;
      background-repeat: no-repeat;
      z-index: 1;
    }

    .portrait {
      flex-basis: 50%;
      img {
        /* width: 100%; */
        width: 100%;
      }
      z-index: 1;
    }

    .info {
      flex-basis: 50%;
      font-family: "GT Super Text";
      text-align: left;
      z-index: 2;

      .subtext {
        margin-bottom: 20px;
        opacity: .6;
      }

      h1,
      h2 {
        font-family: "GT Super Text";
        font-size: 60px;
        margin-left: 0px;
        font-weight: 500;
        margin-bottom: 20px;
      }

      h2 {
        font-size: 25px;
      }

      .description {
        font-size: 22px;
        line-height: 1.6;
        margin-bottom: 20px;
        max-width: 750px;
      }

      .links {
        display: flex;
        flex-direction: row;
        gap: 20px;
        margin-bottom: 20px;
        align-items: center;

        a {
          display: block;
          font-family: 'Inter';
          padding: 2px 12px 12px 12px;
          font-weight: 500;
          border: 2px solid rgba(255,255,255,.3);
          border-radius: 13px;
          font-size: 16px;


          p {
            margin-bottom: 5px;


            }
            svg {
              position: relative;
              top: 6px;
            }
          }

          span {
            opacity: .6;
          }
        }
      }
    }
  }
  @media only screen and  (max-width: 1110px) {
      .border{ display: none;}
      .corner-logo{
        left: 50%;
        transform: translateX(-50%);
        top: 15px;
        svg{
          height: 40px;
          width: 85px;
        }
      }
      .creator{
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        padding-bottom:0px;
        height:auto;
        .info {
          margin-top: 14px;
          display: block;
          .description {
            font-size: 20px;
          }
          .subtext{
            display: none;
            margin-bottom:.7rem;
          }

          h1{
            font-size: 64px;
            margin-top:42px;
            margin-bottom:12px;
            text-align: center;
          }
          text-align:center;
          .links{
            gap: 12px;
            justify-content: center;

            a {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              font-size: 14px;
              p {
                width: auto;
              }
            }
          }
        }
        .hide-on-mobile{
          display:none;
        }
        .plugins-tray{
          display: block;
          background:#fff;
          padding: 64px 12px 64px 12px;
          margin-top:-100px;
          z-index:10000;
          width: calc(100vw - 20px);
          box-shadow: var(--card-drop-shadow);
          h2 {
            font-family:'GT Super Text';
            font-weight: 400;
            font-size: 32px;
            padding-bottom: 12px;
          }
          div{
            flex-direction: row;
            flex-wrap: wrap;

            .plugin{
              margin-left:10px;
              width: calc(50% - 53px);
              box-shadow:var(--card-drop-shadow);
            }
          }
        }
        .plugins-inline{
          display: none;
        }
        .image {
          position: relative;
          height: auto;
          display:block;
          width: 100vw;
          background-size: 100%;
        }
      }
    }

        //mobile
  @media only screen and  (max-width: 768px) {
      .border{ display: none;}
      .corner-logo{
        left: 50%;
        transform: translateX(-50%);
        top: 15px;
        svg{
          height: 40px;
           width: 85px;
        }
      }
      .creator{
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        padding-bottom:0px;
        height:auto;
        .info {
          margin-top: 14px;
          display: block;
          .description {
            font-size: 15px;
          }
          .subtext{
            display: none;
            margin-bottom:.7rem;
          }

          h1{
            font-size: 32px;
            margin-top:42px;
            margin-bottom:12px;
            text-align: center;
          }
          text-align:center;
          .links{
            gap: 12px;
            justify-content: center;

            a {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              font-size: 14px;
              p {
                width: auto;
              }
            }
          }
        }
        .hide-on-mobile{
          display:none;
        }
        .plugins-tray{
          display: block;
          background:#fff;
          padding: 36px 12px 48px 12px;
          margin-top:-20px;
          z-index:10000;
          width: calc(100vw - 20px);
          box-shadow: var(--card-drop-shadow);
          h2 {
            font-family:'GT Super Text';
            font-weight: 400;
          }
          div{
            flex-direction: column;
            .plugin{
              margin-left:10px;
              width: calc(100vw - 70px);
              box-shadow:var(--card-drop-shadow);
            }
          }
        }
        .plugins-inline{
          display: none;
        }
        .image {
          position: relative;
          height: auto;
          display:block;
          width: 100vw;
          background-size: 100%;
        }
      }
    }

  .footer-container {
    /* margin-top: 2em; */
    background: none;
  }

`;
